import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // For navigation
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2"; // Import SweetAlert2
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";

const AllCategory = () => {
  const [menus, setMenus] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [tableData, setTableData] = useState([]);

  const navigate = useNavigate(); // For navigation

  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(response.data);
        setDropdownOptions([response.data.filter(menu => menu.parent_id === null)]);
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  const handleCategoryChange = (index, selectedId) => {
    if (!selectedId) return;

    const newSelectedCategories = [...selectedCategories];
    newSelectedCategories[index] = selectedId;
    newSelectedCategories.length = index + 1; // Remove deeper selections
    setSelectedCategories(newSelectedCategories);

    const subCategories = menus.filter(menu => menu.parent_id === parseInt(selectedId));
    const newDropdownOptions = [...dropdownOptions];

    if (subCategories.length > 0) {
      newDropdownOptions[index + 1] = subCategories;
    } else {
      newDropdownOptions.length = index + 1; // Remove further dropdowns
    }
    setDropdownOptions(newDropdownOptions);

    updateTableData(newSelectedCategories);
  };

  const updateTableData = (selectedCategories) => {
    const newRow = selectedCategories.map(categoryId => {
      const category = menus.find(m => m.id === parseInt(categoryId));
      return category ? { id: category.id, title: category.title } : { id: null, title: "-" };
    });

    setTableData([newRow]); // Store latest row
  };

  const handleEdit = (categoryId) => {
    navigate(`/admin/edit-category/${categoryId}`); // Redirect to edit page
  };

  // Handle Delete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this! All dependent categories will also be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseurl}deleteMenuById/${id}`)
          .then(() => {
            Swal.fire("Deleted!", "Your menu has been deleted.", "success");
            window.location.reload(); // Reload the page after deletion
          })
          .catch((error) => {
            console.error("Error deleting menu:", error);
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <h4 className="mb-3 text-start">All Categories</h4>

          {/* Dynamic Dropdowns */}
          <div className="crd1 mb-3">
            <div className="row">
              {dropdownOptions.map((options, index) => (
                <div className="col-md-3" key={index}>
                  <label className="form-label">Select Category Level {index + 1}</label>
                  <select
                    className="form-select"
                    value={selectedCategories[index] || ""}
                    onChange={(e) => handleCategoryChange(index, e.target.value)}
                  >
                    <option value="">Select Category</option>
                    {options.map(menu => (
                      <option key={menu.id} value={menu.id}>
                        {menu.title}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
          </div>

          {/* Category Table */}
          <div className="crd1">
            <div className="table-responsive mt-4">
              <table className="custom-table">
                <thead>
                  <tr>
                    {selectedCategories.map((_, index) => (
                      <th key={index}>{`Category Level ${index + 1}`}</th>
                    ))}
                    {selectedCategories.length > 0 && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 && (
                    <tr>
                      {tableData[0].map((category, colIndex) => (
                        <td key={colIndex}>{category.title}</td>
                      ))}
                      {selectedCategories.length > 0 && (
                        <td>
                          <button
                            className="btn btnedit me-2"
                            onClick={() => handleEdit(tableData[0][tableData[0].length - 1].id)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btndelete"
                            onClick={() => handleDelete(tableData[0][tableData[0].length - 1].id)}
                          >
                            Move To Trash
                          </button>
                        </td>
                      )}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AllCategory;
